import { safeReturnTo } from './config';

const protectedPath = (pathname: string) =>
  pathname === '/' ||
  pathname === '/properties' ||
  pathname.startsWith('/properties/') ||
  pathname === '/contracts' ||
  pathname.startsWith('/contracts/') ||
  pathname === '/stays' ||
  pathname.startsWith('/stays/') ||
  pathname === '/dev' ||
  pathname.startsWith('/dev/') ||
  pathname === '/access' ||
  /^\/access\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
    pathname,
  );

export function expiredSessionLoginPath(
  pathname: string,
  search: string,
  status: string,
  generation: number,
): string | null {
  if (!protectedPath(pathname) || status !== 'unauthenticated' || generation === 0) return null;
  let returnTo = '/properties';
  try {
    returnTo = safeReturnTo(`${pathname}${search}`);
  } catch {
    // Keep a safe default if an unexpected protected route is malformed.
  }
  return `/login?returnTo=${encodeURIComponent(returnTo)}`;
}
